import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IGroupFollowUpTask } from "../../utils/types/models";

export default createEntityReducer<IGroupFollowUpTask>(Endpoint.GroupFollowUpTasks, Endpoint.GroupFollowUpTasksList);
